import type { RootState } from '~/redux/store';
import type { SourceEmail } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<SourceEmail> => ({
  sortBy: state.sourceEmails.sortBy,
  page: state.sourceEmails.page,
  pageSize: state.sourceEmails.pageSize,
  with: state.sourceEmails.with.join(','),
  ...state.sourceEmails.filters,
});

export const getItem = (state: RootState): SourceEmail | null => state.sourceEmails.item;

export const getInitialItem = (state: RootState): string | null => state.sourceEmails.initialItem;
